export const confirmModalStyles = {
  title: {},
  buttonBox: {},
  container: {},
  containerMobile: {},
}
